var React = require('react');

function Wand (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard"),React.createElement("path",{"d":"M2.5 4A1.5 1.5 0 0 0 1 2.5 1.5 1.5 0 0 0 2.5 1 1.5 1.5 0 0 0 4 2.5 1.5 1.5 0 0 0 2.5 4zm.5 8a2 2 0 0 0-2-2 2 2 0 0 0 2-2 2 2 0 0 0 2 2 2 2 0 0 0-2 2zm10-8.5A2.5 2.5 0 0 0 10.5 6 2.5 2.5 0 0 0 8 3.5 2.5 2.5 0 0 0 10.5 1 2.5 2.5 0 0 0 13 3.5zm-.607 10.697a1 1 0 0 1-1.111-.208L3.74 6.448a1 1 0 0 1-.208-1.111c.183-.414.426-.773.728-1.076a3.513 3.513 0 0 1 1.076-.728 1 1 0 0 1 1.111.208l7.541 7.54a1 1 0 0 1 .208 1.112 3.513 3.513 0 0 1-.728 1.076 3.513 3.513 0 0 1-1.076.728zM6 6.002c.216-.216.466-.397.75-.544l-1.01-1.01a2.515 2.515 0 0 0-.771.52c-.214.214-.387.47-.521.773l1.01 1.01A2.97 2.97 0 0 1 6 6.003z","fill":"currentColor","fillRule":"evenodd","key":1})]);
}

Wand.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Wand;

Wand.default = Wand;
